import angular from 'angular';
import selectGdriveFolderModal from './selectGdriveFolderModal';

export default angular
  .module('components.selectGdriveFolderModal', [])
  .component('selectGdriveFolderModal', selectGdriveFolderModal).name;
